// frontend/src/components/auth/ProtectedRoute.tsx

import { ReactNode, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { UserRole } from '../../types/auth.types';
import { authService } from '../../services/auth.service';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Belirtilirse, yalnızca bu rollerden biri sayfaya erişebilir. */
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { session, profile, isLoading, isRecovery } = useAuthStore();
  const navigate = useNavigate();

  // Banlı kullanıcıyı otomatik olarak çıkış yaptır
  useEffect(() => {
    if (profile?.is_banned) {
      authService.signOut().catch(() => {}).finally(() => {
        navigate('/auth', { replace: true, state: { bannedError: true } });
      });
    }
  }, [profile?.is_banned, navigate]);

  if (isLoading) {
    return <div className="auth-loading">Yükleniyor...</div>;
  }

  if (isRecovery || window.location.hash.includes('type=recovery') || window.location.search.includes('type=recovery')) {
    return <Navigate to="/reset-password" replace />;
  }

  if (!session) {
    return <Navigate to="/auth" replace />;
  }

  // Banlı kullanıcı — effect logout'u hallediyor, bu arada boş render döndür
  if (profile?.is_banned) {
    return null;
  }

  if (allowedRoles && profile && !allowedRoles.includes(profile.role)) {
    const fallback =
      profile.role === 'parent'
        ? '/parent'
        : profile.role === 'admin'
        ? '/admin'
        : '/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
